<div class="login-wrapper">
  <div class="login-page-topbar">
    <button
      mat-icon-button
      type="button"
      class="theme-toggle-btn"
      [matTooltip]="(ThemeService.isLightTheme ? 'GENERAL.DARK_THEME' : 'GENERAL.LIGHT_THEME') | translate"
      (click)="ThemeService.toggleTheme()"
    >
      <mat-icon>{{ !ThemeService.isLightTheme ? "light_mode" : "dark_mode" }}</mat-icon>
    </button>

    <div class="login-page-language">
      <button
        type="button"
        mat-button
        class="login-page-language__trigger"
        [matMenuTriggerFor]="loginLanguageMenu"
        [attr.aria-label]="'GENERAL.LANGUAGE' | translate"
      >
        <img class="login-page-language__flag" [src]="getSelectedLanguageIcon()" alt="" />
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #loginLanguageMenu="matMenu" class="settings-menu login-page-language__menu">
        @for (item of languageOptions; track item.id) {
          <button
            type="button"
            mat-menu-item
            (click)="setLanguage(item.id)"
            [class.menu-dropdown-button-active]="item.active"
            class="language-menu-item"
          >
            <img [src]="languageFlagSrc(item.image)" [attr.alt]="item.name | translate" [attr.title]="item.name | translate" />
            <span>{{ item.name | translate }}</span>
          </button>
        }
      </mat-menu>
    </div>
  </div>

  <!-- Left panel: brand -->
  <div class="brand-panel">
    <!-- Floating financial icons -->
    <div class="float-icon fi-1"><mat-icon>trending_up</mat-icon></div>
    <div class="float-icon fi-2"><mat-icon>payments</mat-icon></div>
    <div class="float-icon fi-3"><mat-icon>pie_chart</mat-icon></div>
    <div class="float-icon fi-4"><mat-icon>account_balance</mat-icon></div>
    <div class="float-icon fi-5"><mat-icon>currency_exchange</mat-icon></div>
    <div class="float-icon fi-6"><mat-icon>bar_chart</mat-icon></div>
    <div class="float-icon fi-7"><mat-icon>savings</mat-icon></div>
    <div class="float-icon fi-8"><mat-icon>receipt_long</mat-icon></div>
    <div class="float-icon fi-9">
      <div class="powered-by-ngx-stack">
        <div class="brand-ngx">
          <img
            class="powered-by-ngx-img"
            [src]="'./assets/plus2/powered-by-ngx-dark.svg'"
            [attr.alt]="'LOGIN_PAGE.POWERED_BY_ALT' | translate"
          />
        </div>
      </div>
    </div>

    <!-- Spotlight -->
    <div class="spotlight"></div>

    <div class="brand-content">
      <h1 class="brand-name">
        @if (logo) {
          <div class="logo" fxLayout="100">
            <img
              [attr.title]="'LOGIN_PAGE.LOGO_ALT' | translate"
              [attr.alt]="'LOGIN_PAGE.LOGO_ALT' | translate"
              [src]="logo"
              style="height: 60px; width: auto; max-width: 100%"
            />
          </div>
        }
        <p class="brand-eyebrow">
          {{ "LOGIN_PAGE.BRAND_EYEBROW" | translate }}
        </p>
        <span class="brand-financial">{{ "LOGIN_PAGE.BRAND_NAME" | translate }}</span>
      </h1>
      <p class="brand-tagline" [innerHTML]="'LOGIN_PAGE.TAGLINE' | translate"></p>
    </div>
  </div>

  <!-- Right panel: form -->
  <div class="form-panel">
    <div class="form-panel__content">
      <div class="form-card">
        <div class="form-header">
          <h2>{{ "LOGIN_PAGE.FORM_TITLE" | translate }}</h2>
          <p>{{ "LOGIN_PAGE.FORM_SUBTITLE" | translate }}</p>
        </div>

        <app-global-login
          (successLogin)="success()"
          [hideRegisterButton]="true"
          [hideOptions]="true"
          [invertedLabel]="true"
          minWidth="300px"
        ></app-global-login>
      </div>
    </div>

    <div class="login-footer-meta">
      <img
        class="login-footer-meta__ngx"
        [src]="'./assets/plus2/powered-by-ngx-dark.svg'"
        [attr.alt]="'LOGIN_PAGE.POWERED_BY_ALT' | translate"
      />
      <p class="login-app-version login-app-version--footer">
        {{ appVersionLabel }}
      </p>
    </div>
  </div>
</div>
